export const getCustomRoutes = state => state.customRoutes;
